import React, { Component } from 'react';
import { Modal, Spin, Button, Carousel, Icon } from 'antd';
import { basicDetailsSchema } from '../../../schema/counselling_form';
import networkList from '../../../constants/networkList';
import postService from '../../../services/httpService';
import Storage from '../../../services/local-store';
import moment from 'moment';

var url = window.location.href
var arr = url.split("/");
class Non_Counselling_form extends Component {
    constructor(props) {
        super(props)
        this.state = {
            'loadding': false,
            visible: false,
            'basicDetailsSchema': basicDetailsSchema['feilds'],
            form_openn: 'comment',
            addText: '',
            pre_link: '',
            view_mode: false,
            error: false,
            counselling_details:'',
            final_save:false
        }
    }

    componentDidMount() { 
        let { slug } = this.props.match.params;
        switch (slug) {
            case 'basic-details':
                this.setState({ comment_disable: false, view_mode: false })
                break;
            case 'view-finanical-counselling':
                let { counselling_details } = this.props;
                let com = this.props.basic_info
            Storage.store('current_print', {
                "counselling_id": counselling_details['counselling_id'],
                "payment_type": counselling_details['payment_type_id'],
            })
                this.setState({ comment_disable: true, comments: com.comments_data, view_mode: true })
                break;
            default:
                break;
        }
    }

    componentWillUnmount() {
        this.setState({
            visible: false,
            formData: []
        });
    }

    cancel() {
        
        let { slug } = this.props.match.params;
        switch (slug) {

        }
    }


    validateModalFeilds(formFeilds) {
        let errors = [];
        let role_id = null;
        formFeilds.map((feild, key) => {
            if ((feild['element'] === 'input' || feild['element'] === 'select2' || feild['element'] === 'Select2multiple' || feild['element'] === 'date')) {
                if (feild['name'] === 'role_id' && feild['value'] === 'RL_HjPW') {
                    role_id = true;
                } else {
                    role_id = false;
                }
                formFeilds[key]['errors'] = [];
                if (!feild.disable) {
                    feild
                        .rules
                        .map((rule, rkey) => {
                            if (rule.test !== undefined && typeof rule.test === 'function' && !rule.test(feild['value'])) {
                                if (feild['name'] === 'counsellor_type') {
                                    formFeilds.map((feil, ke) => {
                                        if (feil['name'] === 'role_id' && feil['value'] === 'RL_HjPW' && feil['value'] !== null) {
                                            if (!(feild['value'] === '') || !(feild['value'] === null) || !(feild['value'] === undefined)) {
                                                formFeilds[key]['errors'].push({ 'message': rule.message });
                                                errors.push(false);
                                            }
                                            else {
                                                console.log('no', feild['name'], feild['value'])
                                                formFeilds[key]['errors'] = [];
                                                errors.push(true);
                                            }
                                        }
                                    })
                                }
                                else {
                                    formFeilds[key]['errors'].push({ 'message': rule.message });
                                    errors.push(false);
                                }
                            }
                            else {
                                formFeilds[key]['errors'] = [];
                                errors.push(true);
                            }
                        })
                }
            }
        })

        this.setState((state) => ({ basicDetailsSchema: formFeilds }));
        return errors;
    }

    buttonClick(feilds, type) {
        console.clear();
        // console.log('feilds', type, feilds);
    }

    buttonClick1(feilds, type) {
        console.clear();
        // console.log('feilds', type);
    }

    buttonClick_cancel() {
        this.props.back()
    }

    addCash(feilds) {

    }

    feildChange1(ele) {
        console.clear();
        // console.log(ele);
    }

    save() {
        let { comments } = this.state;
        let playload = this.props.basic_info;
        let counsellingData = JSON.parse(Storage.get('user_data'));
        let counseller_Name = counsellingData.username;
        console.log("counseller_Name:::",counseller_Name);
        let patientCheckIn = JSON.parse(Storage.get('fc_checklist_verified'));
        let payload ={
            ...playload,
            "fc_checklist_verified": patientCheckIn,
            "counseller_name":counseller_Name,
        };
        Object.assign(payload, { comments: comments });
        localStorage.removeItem('completed_counselling_date');
        if (comments) {
            this.setState({final_save:true})
            // console.log('success:', playload)
            try {
                    postService('getconfigurations', 'GET', 'null').then(res => {
                        if (res.status) {
                            if (res.data.length > 0) {
                                if (res.data[0].data.length > 0) {
                                    res.data[0].data.map((feilds, key) => {
                                        if (feilds.config_name === 'Print Waiting Time') {
                                         localStorage.setItem('printTimeWait',feilds.bill_tracking_percent);
                                        }
                                    })
                                }
                            }
                            else {
                                Modal.error({
                                    title: 'Error message',
                                    content: 'No service available',
                                });
                            }
                        } 
                        else {
                            Modal.error({
                                title: 'Error message',
                                content: 'Something went wrong',
                            });
                        }
                    });
                
                const { createFinancialCouncelling } = networkList;
                this.setState((state) => ({ thead: this.state.tableHead, loadding: true, error: false }), () => {
                    postService(createFinancialCouncelling, 'POST', { data: payload }).then(res => {
                        console.log('res:', res)
                        if (res.status) {
                            localStorage.setItem('completed_counselling_date',moment());
                            this.setState((state) => ({ loadding: false }));
                            Modal.success({
                                title: 'Success Message',
                                content: res.message ? res.message : 'Counselling Sucessfully Completed'
                            })                          
                            // Storage.remove('current_token');
                            Storage.store('current_print', res.data);
                            Storage.remove('fc_checklist_verified');
                            this.props.next();
                           
                        } else {
                            this.setState((state) => ({ message: res.message, loadding: false }));
                            localStorage.setItem('completed_counselling_date',moment());
                            let that=this
                            Storage.store('current_print', res.data);
                            Modal.warning({
                                title: 'Unable to process',
                                content: res.message?res.message:'Please try again later',
                                zIndex:'1035',
                                onOk() {
                                    that.props.next();
                                        }
                            });
                            // to catch api errors like --> network,url,outof status 1,0
                            // Modal.error({
                            //     title: 'Failure',
                            //     content: "Oops! something went wrong... Please try again."
                            // });
                        }
                    });
                });
            } catch (error) {
                console.log(error);
                Modal.error({
                    title: 'Failure',
                    content: "Oops, something went wrong... Please try again.",
                });
            }

        } else {
            this.setState({ error: true })
        }      
    }

    next() {
        this.props.next();
    }

    previous() {
        this.props.back()
    }
    comments(event) {
        let value = event.target.value;
        this.setState((state) => ({ 'comments': value ? value : null }));
    }
    render() {
        let { view_mode, comments, comment_disable, error } = this.state;

        return (
                <Spin spinning={this.state.loadding}>
                    <div className="card mx-5 mb-5 mt-2">
                        <div className="row w-75 mx-auto">
                            <div class="col-12 pb-5 pt-5">
                                <label className="data-label w-100 text-left">Comment *</label>
                                <textarea placeholder="Enter Your Comment..." className="textarea" value={comments ? comments : ''} disabled={comment_disable} onChange={(event) => this.comments(event)}></textarea>
                                {error ? <small className="text-danger">Please Enter Comment.</small> : <small className="text-white">enter</small>}
                            </div>
                        </div>
                        <div className="row justify-content-center mt-3 pb-5">
                            <button className="btn btn-next px-5 mx-2" onClick={this.previous.bind(this)}>Back</button>
                            {view_mode == false && <button className="btn btn-success text-capitalize  px-5 mx-2" onClick={this.save.bind(this)} disable={this.state.final_save}>Save</button>}
                            {view_mode && <button className="btn btn-success text-capitalize  px-5 mx-2" onClick={this.next.bind(this)}>Next</button>}
                        </div>
                    </div>
                </Spin>
        )
    }
}
export default Non_Counselling_form;